webpackJsonp([230488387237203],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(13);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(12);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(31);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  site: {
	    title: 'The Broomwagon',
	    subtitle: 'Girona',
	    caption: 'best coffee experience on location',
	
	    description: 'The Broomwagon. World-class coffee on (three) wheels based in Girona. Bring the Broomwagon to your event to provide your guests with an amazing coffee experience on location. Go to our web shop to buy our beautiful kit!',
	
	    url: 'https://www.thebroomwagongirona.com', // Domain of your site. No trailing slash!
	    // url: 'https://broomwagongirona.netlify.com', // Domain of your site. No trailing slash!
	    pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
	    siteLanguage: 'en', // Language Tag on <html> element
	    siteLogo: '/images/logo.jpg' // Used for SEO and manifest
	  },
	  directus_api: {
	    // url: `http://localhost`,
	    url: 'api.thebroomwagongirona.com',
	    protocol: 'http',
	    apiKey: 'etIfgwbpyKszCdBPYh7dUsYDyX8oDk3Y'
	  },
	  google: {
	    analyticsID: 'UA-19600184-9'
	  }
	};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	__webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTA = function CTA(props) {
	  return props.external ? _react2.default.createElement(
	    _gatsbyPluginGoogleAnalytics.OutboundLink,
	    { rel: 'nofollow', className: 'cta' + (props.light ? " light" : "") + ' ' + (props.className ? props.className : ""), href: props.to, target: '_blank' },
	    props.label
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: 'cta' + (props.light ? " light" : "") + ' ' + (props.className && props.className), to: props.to },
	    props.label
	  );
	};
	
	exports.default = CTA;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(10);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(363);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	var _ProductSelector = __webpack_require__(144);
	
	var _ProductSelector2 = _interopRequireDefault(_ProductSelector);
	
	var _Sizetable = __webpack_require__(92);
	
	var _Sizetable2 = _interopRequireDefault(_Sizetable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Product = function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product(props) {
	    _classCallCheck(this, Product);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Product.prototype.render = function render() {
	
	    var sizesByGender = {};
	
	    var sizeData = this.props.stock ? this.props.stock : this.props.sizes;
	
	    var multipleSizes = false;
	
	    sizeData.data.map(function (sizeData, key) {
	      if (!(sizeData.sex in sizesByGender)) {
	        sizesByGender[sizeData.sex] = [];
	      }
	      sizesByGender[sizeData.sex].push(sizeData);
	      multipleSizes = key > 0;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'product' },
	      _react2.default.createElement(_gatsbyImage2.default, { alt: this.props.title, className: 'image', resolutions: this.props.image.resolutions }),
	      _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.props.description } }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'more pictures on instagram: ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: 'https://www.instagram.com/explore/tags/' + this.props.instagramHashtag.replace('#', ''), target: '_blank' },
	            '#',
	            this.props.instagramHashtag.replace('#', '')
	          )
	        ),
	        multipleSizes && _react2.default.createElement(_Sizetable2.default, null),
	        _react2.default.createElement(
	          'p',
	          { className: 'price' },
	          _react2.default.createElement(
	            'span',
	            { className: 'currency' },
	            '\u20AC'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'amount' },
	            Number.parseFloat(this.props.price).toFixed(2).replace('€', '')
	          ),
	          ' excl. shipping'
	        ),
	        _react2.default.createElement(_ProductSelector2.default, {
	          product: this.props.product,
	          productId: this.props.productId,
	          sizes: this.props.stock,
	          stock: sizesByGender
	        })
	      )
	    );
	  };
	
	  return Product;
	}(_react2.default.Component);
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductSelector = function (_React$Component) {
	  _inherits(ProductSelector, _React$Component);
	
	  function ProductSelector(props) {
	    _classCallCheck(this, ProductSelector);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleGenderChange = _this.handleGenderChange.bind(_this);
	    _this.handleSizeChange = _this.handleSizeChange.bind(_this);
	    _this.handleAmountChange = _this.handleAmountChange.bind(_this);
	
	    var tmpSelectedGender = Object.keys(_this.props.stock).length > 1 ? false : "u";
	    var tmpSelectedSize = tmpSelectedGender && _this.props.stock["u"] != undefined && _this.props.stock["u"].length == 1 ? "0" : false;
	
	    _this.state = {
	      selectedGender: tmpSelectedGender,
	      selectedSize: tmpSelectedSize,
	      selectedAmount: 0,
	      errorMessage: false
	    };
	
	    return _this;
	  }
	
	  ProductSelector.prototype.handleGenderChange = function handleGenderChange(element) {
	    this.setState({
	      selectedGender: element.target.value,
	      errorMessage: false,
	      selectedAmount: 0
	    });
	  };
	
	  ProductSelector.prototype.handleSizeChange = function handleSizeChange(element) {
	    this.setState({
	      selectedSize: element.target.value,
	      errorMessage: false,
	      selectedAmount: 0
	    });
	  };
	
	  ProductSelector.prototype.handleAmountChange = function handleAmountChange(element) {
	    if (this.props.stock[this.state.selectedGender][this.state.selectedSize].count == 0) {
	      this.setState({
	        selectedAmount: 0,
	        errorMessage: "out of stock"
	      });
	    } else if (element.target.value >= this.props.stock[this.state.selectedGender][this.state.selectedSize].count) {
	      this.setState({
	        selectedAmount: this.props.stock[this.state.selectedGender][this.state.selectedSize].count,
	        errorMessage: "only " + this.props.stock[this.state.selectedGender][this.state.selectedSize].count + " items left in stock"
	      });
	    } else if (element.target.value < 0) {
	      this.setState({
	        selectedAmount: 0,
	        errorMessage: false
	      });
	    } else {
	      this.setState({
	        selectedAmount: element.target.value,
	        errorMessage: false
	      });
	    }
	  };
	
	  ProductSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var orderId = false;
	    var orderName = false;
	
	    var genders = Object.keys(this.props.stock).length > 1; //multiple genders?
	    var sizes = genders || !genders && this.props.stock["u"] != undefined && this.props.stock["u"].length > 1; //multiple sizes?
	
	    if (this.state.selectedGender && this.state.selectedSize && this.state.selectedAmount > 0) {
	      orderId = "product_" + this.props.stock[this.state.selectedGender][this.state.selectedSize].id;
	
	      orderName = this.props.product.title;
	      if (genders) {
	        orderName += " " + this.state.selectedGender;
	      }
	      if (sizes) {
	        orderName += " " + this.props.stock[this.state.selectedGender][this.state.selectedSize].size;
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: "productSelector" + (this.props.sizes ? " loaded" : " loading") },
	      genders && _react2.default.createElement(
	        'span',
	        { className: 'gender' },
	        'gender:',
	        _react2.default.createElement(
	          'select',
	          { disabled: this.props.sizes == false, defaultValue: 'gender', onChange: function onChange(e) {
	              return _this2.handleGenderChange(e);
	            } },
	          _react2.default.createElement(
	            'option',
	            { value: 'gender', disabled: true },
	            'gender'
	          ),
	          this.props.stock && Object.keys(this.props.stock).map(function (x, index) {
	            return _react2.default.createElement(
	              'option',
	              { key: index, value: x },
	              x
	            );
	          })
	        )
	      ),
	      sizes && _react2.default.createElement(
	        'span',
	        { className: 'size' },
	        'size:',
	        _react2.default.createElement(
	          'select',
	          { disabled: this.props.sizes == false || this.state.selectedGender == false, defaultValue: 'size', onChange: function onChange(e) {
	              return _this2.handleSizeChange(e);
	            } },
	          _react2.default.createElement(
	            'option',
	            { value: 'size', disabled: true },
	            'size'
	          ),
	          this.props.stock && this.state.selectedGender && this.props.stock[this.state.selectedGender].map(function (elem, index) {
	            return _react2.default.createElement(
	              'option',
	              { key: index, value: index, disabled: elem.count <= 0 },
	              elem.count <= 0 ? elem.size + " out of stock" : elem.size
	            );
	          })
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'amount' },
	        'amount:',
	        _react2.default.createElement('input', {
	          disabled: !this.state.selectedGender || !this.state.selectedSize,
	          className: 'amount',
	          type: 'number',
	          value: this.state.selectedAmount,
	          onChange: function onChange(e) {
	            return _this2.handleAmountChange(e);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'snipcart-add-item',
	          'data-item-id': orderId,
	          'data-item-name': orderName,
	          'data-item-price': parseFloat(Math.round(this.props.product.price * 100) / 100).toFixed(2),
	          'data-item-url': 'https://broomwagongirona.netlify.com/products/prices/' + orderId + '/',
	          disabled: !orderId,
	          'data-item-quantity': orderId && this.state.selectedAmount,
	          'data-item-max-quantity': orderId && this.props.stock[this.state.selectedGender][this.state.selectedSize].count
	        },
	        'Add to cart'
	      ),
	      this.state.errorMessage && _react2.default.createElement(
	        'span',
	        { className: 'error' },
	        this.state.errorMessage
	      )
	    );
	  };
	
	  return ProductSelector;
	}(_react2.default.Component);
	
	exports.default = ProductSelector;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(10);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'homepageSection section' },
	    _react2.default.createElement(_gatsbyImage2.default, { alt: props.title, className: 'round', outerWrapperClassName: 'image', resolutions: props.image.childImageSharp.resolutions }),
	    _react2.default.createElement(
	      'div',
	      { className: 'text' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        props.children
	      ),
	      props.CTA && props.CTA
	    )
	  );
	};
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sizetable = function Sizetable(props) {
	    return _react2.default.createElement(
	        'p',
	        { className: 'sizetable' },
	        '*Sismic kit sizes are quite small, make sure to ',
	        _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: '/sismic_sizetable.pdf', target: '_blank' },
	            'check out our size guide'
	        ),
	        '!'
	    );
	};
	
	exports.default = Sizetable;
	module.exports = exports['default'];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.shopQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	var _Product = __webpack_require__(143);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Section = __webpack_require__(57);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CTA = __webpack_require__(30);
	
	var _CTA2 = _interopRequireDefault(_CTA);
	
	var _Sizetable = __webpack_require__(92);
	
	var _Sizetable2 = _interopRequireDefault(_Sizetable);
	
	var _settings = __webpack_require__(43);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebshopPage = function (_React$Component) {
	  _inherits(WebshopPage, _React$Component);
	
	  function WebshopPage(props) {
	    _classCallCheck(this, WebshopPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      error: null,
	      isLoaded: true,
	      // isLoaded: false,
	      stock: false
	    };
	    return _this;
	  }
	
	  // componentDidMount() {
	  //   const stockArr = {};
	
	  //   const url = `${settings.directus_api.protocol}://${
	  //     settings.directus_api.url
	  //   }/api/1.1/tables/products/rows`;
	
	  //   fetch(url, {
	  //     method: 'get',
	  //     headers: new Headers({
	  //       Authorization: `Bearer ${settings.directus_api.apiKey}`,
	  //       'Access-Control-Request-Method': 'get',
	  //     }),
	  //   })
	  //     .then(res => res.json())
	  //     .then(
	  //       (result) => {
	  //         result.data.map((elem, index) => {
	  //           stockArr[`directus_id_${elem.id}`] = elem.sizes;
	  //         });
	  //         this.setState({
	  //           isLoaded: true,
	  //           stock: stockArr,
	  //         });
	  //       },
	  //       // Note: it's important to handle errors here
	  //       // instead of a catch() block so that we don't swallow
	  //       // exceptions from actual bugs in components.
	  //       (error) => {
	  //         console.log(error);
	  //       },
	  //     );
	  // }
	
	  WebshopPage.prototype.render = function render() {
	    var _state = this.state,
	        error = _state.error,
	        isLoaded = _state.isLoaded,
	        stock = _state.stock;
	
	
	    var productImages = {};
	    this.props.data.allFile.edges.map(function (_ref, index) {
	      var node = _ref.node;
	
	      productImages[node.childImageSharp.resolutions.originalName] = node.childImageSharp;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'webshop page' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'webshop'
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        {
	          image: this.props.data.kitImage.edges[0].node,
	          title: 'Cycling Kit',
	          CTA: _react2.default.createElement(_CTA2.default, { to: '#contact', label: 'Get in touch!' })
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\u2019re thrilled to work in collaboration with Sismic, a Catalan company based in Olot. Using the finest materials and newest technologies we have created a fantastic kit available for men and women and on special requests we can also order kids sizes for our youngest fans.'
	        ),
	        _react2.default.createElement(_Sizetable2.default, null),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Custom Jerseys'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you really like The Broomwagon design but want to add the logo of your business on the back? That\u2019s possible from now on. Prices from \u20AC130.'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Shipping and returns'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Of course we offer worldwide shipping for all our items. ',
	          _react2.default.createElement('br', null),
	          'Europe: \u20AC14.95 - Outside Europe: \u20AC19.95'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Once we\u2019ve received your order and payment you can expect your package within 5 days. If the size isn\'t right or your item isn\'t as you expected you could return them within 11 days. We can only refund returned items if you notify us by email and send us a tracking code. The costumer will cover reshipping costs.'
	        )
	      ),
	      this.props.data.allDirectusProduct.edges.map(function (_ref2, index) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_Product2.default, {
	          key: index,
	          title: node.title,
	          product: node,
	          productId: node.directusId,
	          description: node.description,
	          price: node.price,
	          image: productImages[node.fields.thumbImgUrl],
	          sizes: node.sizes
	          // stock={stock ? stock['directus_id_'+node.directusId] : false}
	          , stock: node.sizes,
	          instagramHashtag: node.instagram_hashtag ? node.instagram_hashtag : false
	        });
	      })
	    );
	  };
	
	  return WebshopPage;
	}(_react2.default.Component);
	
	WebshopPage.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = WebshopPage;
	var shopQuery = exports.shopQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webshop-js-32fe9e66bbabca756c06.js